import http from '@/utils/http'
export const getEmailInfo = data => http.get("/kg-notification/api/error/email", {
    params: data
}) //查找邮件通知
export const exportCord = data => http.get('/kg-notification/api/error/email/excel', {
    params: data,
    responseType: 'blob'
})
export default {
    getEmailInfo,
    exportCord
}